// Future contracts are calculated according containers count and Species
// Arabica 1 cont = 1 contract, Robusta 1 cont = 2 contracts

export const calculateFutureContract = ({ containers, species }) => {
  return species === 'Robusta' ? containers * 2 : containers;
};
